module.exports = __webpack_public_path__ + "static/Cobo-15ef651d224caa3dc055feab2f830fe8.png";